export class GRPCEnvironment {
  domain!: string;
  mainApidomain!: string;
  cookieName!: string;
}
